import { OccupationCard } from '@cpd-app/generated';
import { createAction, props } from '@ngrx/store';

export const loadFavoriteOccupations = createAction(
  '[FavoriteOccupations] Load Favorite Occupations'
);

export const favoriteOccupationsLoadedSuccess = createAction(
  '[FavoriteOccupations] Favorite Occupations Loaded Success',
  props<{ favoriteOccupations: OccupationCard[] }>()
);

export const addFavoriteOccupation = createAction(
  '[FavoriteOccupations] Add Favorite Occupation',
  props<{ onetCode: string; jobId: number }>()
);

export const favoriteOccupationAddedSuccess = createAction(
  '[FavoriteOccupations] Favorite Occupation Added Success',
  props<{ favoriteOccupation: OccupationCard }>()
);

export const removeFavoriteOccupation = createAction(
  '[FavoriteOccupations] Remove Favorite Occupation',
  props<{ onetCode: string; jobId: number }>()
);

export const favoriteOccupationRemovedSuccess = createAction(
  '[FavoriteOccupations] Favorite Occupation Removed Success',
  props<{ onetCode: string; jobId: number }>()
);
